// extracted by mini-css-extract-plugin
export default {"cls1":"Header-cls1___02708a99f174ac95d1c","cls2":"Header-cls2__e860bea499bee7d51ee6 Header-cls1___02708a99f174ac95d1c"};